import React, { useState } from 'react';
import { IconPlus, IconSearch, IconGrid, IconEdit, IconTrash } from './Icons';
import './Loans.css';

const SAMPLE_LOANS = [
  {
    id: 2,
    employee: 'Majida Admin (-3.4179687418145E-6/- OMR Balance)',
    amount: '135.591',
    date: '2024-09-01',
    installments: 4,
    deductionFromMonth: '2024-09-01',
  },
  {
    id: 8,
    employee: 'Majida Admin (-3.4179687418145E-6/- OMR Balance)',
    amount: '400',
    date: '2024-12-03',
    installments: 4,
    deductionFromMonth: '2024-10-01',
  },
];

export default function Loans() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLoan] = useState(SAMPLE_LOANS[0]);

  const COLUMNS = [
    { key: 'id', label: 'ID' },
    { key: 'employee', label: 'Employee' },
    { key: 'amount', label: 'Amount' },
    { key: 'date', label: 'Date' },
    { key: 'installments', label: 'Installments' },
    { key: 'deductionFromMonth', label: 'Deduction From Month' },
  ];

  const activeColumnCount = COLUMNS.length + 1; // +1 for actions column

  return (
    <div className="loans-page">
      <div className="loans-card">
        <div className="loans-header-row">
          <h1 className="loans-title">Loans List</h1>
          <div className="loans-header-actions">
            <button
              type="button"
              className="loans-header-btn loans-header-btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              <IconPlus />
              Add Loan
            </button>
          </div>
        </div>

        <div className="loans-filters-row">
          <div className="loans-filters-left">
            <button
              type="button"
              className="loans-layout-toggle"
              aria-label="Layout options"
            >
              <IconGrid />
            </button>
            <button
              type="button"
              className="loans-date-btn"
              aria-label="From date"
            >
              -
            </button>
            <button
              type="button"
              className="loans-date-btn"
              aria-label="To date"
            >
              <span role="img" aria-label="calendar">
                📅
              </span>
            </button>
          </div>

          <div className="loans-filters-right">
            <div className="loans-search">
              <input type="text" placeholder="Search" aria-label="Search loans" />
              <span className="loans-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="loans-table-wrapper">
          <table className="loans-table">
            <thead>
              <tr>
                {COLUMNS.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              {SAMPLE_LOANS.map((loan) => (
                <tr key={loan.id}>
                  <td>{loan.id}</td>
                  <td>{loan.employee}</td>
                  <td>{loan.amount}</td>
                  <td>{loan.date}</td>
                  <td>{loan.installments}</td>
                  <td>{loan.deductionFromMonth}</td>
                  <td>
                    <div className="loans-row-actions">
                      <button
                        type="button"
                        className="loans-row-icon-btn"
                        onClick={() => setShowEditModal(true)}
                        aria-label="Edit loan"
                      >
                        <IconEdit />
                      </button>
                      <button
                        type="button"
                        className="loans-row-icon-btn"
                        onClick={() => setShowDeleteModal(true)}
                        aria-label="Delete loan"
                      >
                        <IconTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="loans-footer-row">
          <div className="loans-footer-left">
            <select
              className="loans-page-size"
              defaultValue="100"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <span>1-2 / 2</span>
          </div>
          <div className="loans-footer-right">
            <button
              type="button"
              className="loans-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="loans-page-btn loans-page-btn-active"
              aria-label="Current page"
            >
              1
            </button>
            <button
              type="button"
              className="loans-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Add Loan</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowAddModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Employee</div>
                <select className="estimates-form-select" defaultValue="">
                  <option value="">-</option>
                </select>

                <div className="estimates-form-label">Amount</div>
                <input className="estimates-form-input" placeholder="Amount" />

                <div className="estimates-form-label">Date</div>
                <input className="estimates-form-input" placeholder="Date" />

                <div className="estimates-form-label">Installments</div>
                <input className="estimates-form-input" defaultValue="1" />

                <div className="estimates-form-label">Deduction From Month</div>
                <input
                  className="estimates-form-input"
                  placeholder="Deduction From Month"
                />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowAddModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">edit_advance</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowEditModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Employee</div>
                <select
                  className="estimates-form-select"
                  defaultValue={selectedLoan.employee}
                >
                  <option value={selectedLoan.employee}>{selectedLoan.employee}</option>
                </select>

                <div className="estimates-form-label">Amount</div>
                <input
                  className="estimates-form-input"
                  defaultValue={selectedLoan.amount}
                />

                <div className="estimates-form-label">Date</div>
                <input
                  className="estimates-form-input"
                  defaultValue={selectedLoan.date}
                />

                <div className="estimates-form-label">Installments</div>
                <input
                  className="estimates-form-input"
                  defaultValue={selectedLoan.installments}
                />

                <div className="estimates-form-label">Deduction From Month</div>
                <input
                  className="estimates-form-input"
                  defaultValue={selectedLoan.deductionFromMonth}
                />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowEditModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowEditModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Delete Loan?</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowDeleteModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="estimates-modal-body">
              <p>Are you sure? You won&apos;t be able to undo this action!</p>
            </div>
            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowDeleteModal(false)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

